import { render, staticRenderFns } from "./RegisterProfile.vue?vue&type=template&id=613c49bb&"
import script from "./RegisterProfile.vue?vue&type=script&lang=js&"
export * from "./RegisterProfile.vue?vue&type=script&lang=js&"
import style0 from "./RegisterProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports